package com.dignicate.web.data.content.static.home

import com.dignicate.web.data.content.ValueStatementDto
import com.dignicate.web.domain.Language
import com.dignicate.web.domain.LocalizedText
import com.dignicate.web.domain.LocalizedTexts

class ValuesContentSource {
    fun values(): List<ValueStatementDto> {
        return listOf(
            ValueStatementDto(
                id = "long_lived_apps",
                title = LocalizedTexts(
                    listOf(
                        LocalizedText(
                            Language.Ja,
                            "長く使えるモバイルアプリをつくる"
                        ),
                        LocalizedText(
                            Language.En,
                            "Build apps that can live for years"
                        )
                    )
                ),
                body = LocalizedTexts(
                    listOf(
                        LocalizedText(
                            Language.Ja,
                            "一度リリースしたアプリは、数年単位で機能追加や仕様変更が続いていきます。目先のスピードだけでなく、数年後の開発者が迷わないコードとアーキテクチャを意識して設計します。"
                        ),
                        LocalizedText(
                            Language.En,
                            "Mobile apps often keep evolving for many years after the first release. We care not only about shipping quickly but also about keeping the architecture understandable for future developers."
                        )
                    )
                )
            ),
            ValueStatementDto(
                id = "small_and_focused",
                title = LocalizedTexts(
                    listOf(
                        LocalizedText(
                            Language.Ja,
                            "小さなチームで、得意な領域に集中する"
                        ),
                        LocalizedText(
                            Language.En,
                            "Stay small and focused"
                        )
                    )
                ),
                body = LocalizedTexts(
                    listOf(
                        LocalizedText(
                            Language.Ja,
                            "モバイル領域に集中することで、限られたリソースでもクオリティを維持できるようにしています。サーバーサイドやデザインなど、他の専門チームがいる場合は、そのチームと協調して動くスタイルです。"
                        ),
                        LocalizedText(
                            Language.En,
                            "We focus on mobile, where we can provide the most value. For design and backend, we are happy to collaborate with your existing specialists or partners."
                        )
                    )
                )
            ),
            ValueStatementDto(
                id = "process_reality",
                title = LocalizedTexts(
                    listOf(
                        LocalizedText(
                            Language.Ja,
                            "実態に合わせたプロセスとコミュニケーション"
                        ),
                        LocalizedText(
                            Language.En,
                            "Processes that match reality"
                        )
                    )
                ),
                body = LocalizedTexts(
                    listOf(
                        LocalizedText(
                            Language.Ja,
                            "ウォーターフォールやアジャイルといった開発手法の呼び方にこだわるのではなく、チームの規模やプロダクトのフェーズに合った現実的な開発フローを一緒に探るスタンスです。"
                        ),
                        LocalizedText(
                            Language.En,
                            "Rather than focusing on how development approaches such as waterfall or agile are labeled, we work with you to find a realistic development flow that fits your team size and product phase."
                        )
                    )
                )
            ),
        )
    }
}
